import React, { useEffect } from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
const Option = Select.Option;
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

@Form.create()
class AddAgreement extends React.Component {
    state = {
        visible: true,
        childrenDrawer: true,
        adId: '',
        countriesArr: [],
        cityArr: [],
        stateArr: [],
        phoneCodes: [],
        leads: [],
        file: '',
        arr: [],
        ext: null,
        linkUrl: null,
        loading: false,
        excelFieldArray: [],
        excelDatas: [],
        paymentUpload: [],
        countriesData: [],
        citiesData: [],
        statesData: [],
        universityPartnerships: [],
        DBFieldsArray: [
            "studentName", 'status', "mode", "selectInquiryType", "dateOfBirth", "gender", "mobile", "watsupp", "emailId", "facebookEmail", "whichYearPlanningToGo", "enqType", "location", "caseHistory", "preference"
        ],
        fieldMappingArray: {},
        statusList: '',
        coursedata: '',
        oldUniversityId: '',

    }


    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId
        })
            .then(resp => {
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        phoneCodes.push(vv.countryPhoneCode);
                    }
                    return temp
                }, [])

                this.setState({ countriesData: resp.data, phoneCodes: phoneCodes });
            })
            .catch(err => {
                console.log(err)
            })
    }


    loadStates = async id => {
        Request.loadStates(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        id: val._id,
                        _id: val._id,
                        display: val.stateName
                    })
                    return total
                }, [])

                this.setState({ statesData: daa.result })
            })
            .catch(err => {
            })
    }
    loadCities = async id => {
        Request.loadCities(id)
            .then(data => {
                data.result = data.result.reduce((total, val) => {
                    total.push({
                        id: val._id,
                        _id: val.cityId,
                        display: val.cityName
                    })
                    return total
                }, [])
                this.setState({ citiesData: data.result })
            })
            .catch(err => {
            })
    }

    async loadPartnerships() {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllUniversityPartnership(params)
        let inputTypes = this.state.inputTypes
        let universityPartnerships = []
        _.each(response.data, (item) => {
            universityPartnerships.push({ _id: item.partnershipName, display: item.partnershipName })
        })

        this.setState({ universityPartnerships: universityPartnerships })
    }


    componentDidMount() {
        this.loadPartnerships();
        this.loadCountries();
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, courseId, data } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                let response = await Request.addAgreement(values)
                if (!response.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: response.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response.msg
                    })
                }
            }

        })
    }

    render() {

        const {
            form: { getFieldDecorator, }
        } = this.props
        const { visible } = this.state

        let inputTypes = {
            fields: [
                {
                    label: 'Select Country',
                    key: 'universityCountryId',
                    required: true,
                    showSearch: true,
                    type: 'select',
                    options: this.state.countriesData,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityCountryId: v,
                            universityStateId: null,
                            universityCityId: null
                        })
                        this.loadStates(v)
                    }
                },
                {
                    label: 'Select State',
                    key: 'universityStateId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    options: this.state.statesData,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityStateId: v,
                            universityCityId: null
                        })
                        this.loadCities(v)
                    }
                },
                {
                    label: 'Select City',
                    key: 'universityCityId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    options: this.state.citiesData,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityCityId: v
                        })
                    }
                },
                {
                    label: 'Institute Name',
                    key: 'universityInstitutionName',
                    required: true
                },
                {
                    label: 'Type',
                    key: 'universityType',
                    type: 'select',
                    required: true,
                    options: ['Language School', 'School', 'College', 'University'],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityType: v
                        })
                    }
                },
                {
                    label: 'Category',
                    key: 'universityCategory',
                    type: 'select',
                    required: true,
                    options: [
                        'Government',
                        'Private',
                        'Not Specified',
                        'SPP',
                        'IPP',
                        'SVP'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityCategory: v
                        })
                    }
                },
                {
                    label: 'Partnership',
                    key: 'universityPartnership',
                    type: 'select',
                    required: true,
                    options: this.state.universityPartnerships,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityPartnership: v
                        })
                    }
                },
                {
                    label: 'Status',
                    key: 'universityStatus',
                    type: 'select',
                    required: true,
                    options: ['Active', 'Block', 'Expired', 'Draft'],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityStatus: v
                        })
                    }
                },
                {
                    label: 'Name',
                    key: 'contactNameThree',
                    prefixComp: <h3>Marketing Person</h3>
                },
                {
                    label: "Country Code",
                    key: "contactPhoneThreeCode",
                    type: "select",
                    showSearch: true,
                    options: this.state.phoneCodes,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ contactPhoneThreeCode: v });
                    },
                },
                {
                    label: 'Phone',
                    key: 'contactPhoneThree',
                    type: 'number'
                },
                {
                    label: 'Email',
                    key: 'contactEmailThree',
                    type: 'email'
                }
            ]
        }


        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add Agreement
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAgreement)
